import { render, staticRenderFns } from "./side-by-side.vue?vue&type=template&id=7a85c9c7"
import script from "./side-by-side.vue?vue&type=script&lang=js"
export * from "./side-by-side.vue?vue&type=script&lang=js"
import style0 from "./side-by-side.vue?vue&type=style&index=0&id=7a85c9c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports